import { render, staticRenderFns } from "./CustomerReviews.vue?vue&type=template&id=2db98fca&scoped=true&"
import script from "./CustomerReviews.vue?vue&type=script&lang=js&"
export * from "./CustomerReviews.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReviews.vue?vue&type=style&index=0&id=2db98fca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db98fca",
  null
  
)

export default component.exports